import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { GET, POST } from '../../Services/AxiosService';
import { CustomStringify } from "../../Helpers/CustomStringify";

export const fetchListClr = createAsyncThunk(
  "ColorNameList/fetchListClr",
  async (cmpdetail, { rejectWithValue }) => {
    
    try {
      const result = await GET(`/colors/${cmpdetail?.key}`);
      return result?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error?.message)
    }
  }
);

const ColorNameListSlice = createSlice({
  name: "ColorNameList",
  initialState: {
    result: [],
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchListClr.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchListClr.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.result = action.payload;
      })
      .addCase(fetchListClr.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export default ColorNameListSlice.reducer;
